(function($) {

    $(document).on('facetwp-refresh', function() {
        if (FWP.soft_refresh == true) {
            FWP.enable_scroll = true;
        } else {
            FWP.enable_scroll = false;
        }
    });

})(jQuery);